import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "m13.293 13.153-.14.139-1.005-1.012-.319-.32-.35.285a5.6 5.6 0 0 1-1.646.93v-.354c.477-.185.913-.44 1.307-.746l.448-.348L7.5 7.64v4.486L4.874 9.5H2.5v-3h3.86L2.707 2.847l.14-.14zM9.833 2.818A5.5 5.5 0 0 1 13.5 8c0 .67-.122 1.31-.345 1.901l-.268-.268c.175-.51.28-1.055.28-1.633a5.17 5.17 0 0 0-3.334-4.832zm0 3.486c.204.22.369.476.483.758l-.483-.483zM7.5 4.246l-.187-.186.187-.187z"
    }, null, -1)
  ]))]))
}
export default { render: render }